import { faker } from '@faker-js/faker';

import type { ChangeZakatDateGetResponse } from '../types/ChangeZakatDateGetResponse';

export function createChangeZakatDateGetResponse(
  data: NonNullable<Partial<ChangeZakatDateGetResponse>> = {}
): NonNullable<ChangeZakatDateGetResponse> {
  return {
    ...{
      data: { notify: faker.datatype.boolean(), zakat_date: faker.string.alpha() },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
